__turbopack_context__.v({
  "app_light_theme": "MorePaginationButton-module-scss-module__szq-Sq__app_light_theme",
  "morePaginationButton": "MorePaginationButton-module-scss-module__szq-Sq__morePaginationButton",
  "morePaginationButton--disabled": "MorePaginationButton-module-scss-module__szq-Sq__morePaginationButton--disabled",
});
